<template>
    <Head title="Privacidade" />
    <Authenticated>
            <HeaderComponent :showExtras="false" />
            <div>
                <Heading title="Privacidade" class="pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28"/>
                <div class="p-4 xl:px-[16vw] min-h-[70vh]">
                    <!-- <PrivacyMockado class="!text-primary"/> -->
                    <div v-html="privacy.text" ></div>
                </div>
            </div>
    </Authenticated>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3';
import Heading from '@/Components/UI/Texts/Heading.vue'
import PrivacyMockado from '@/Components/PrivacyMockado.vue'
import Authenticated from "@/Layouts/Authenticated.vue";
import PrivacyComponent from "@/Pages/PrivacyComponent.vue";

export default {
    components: {
        Heading,
        Head,
        Authenticated,
        PrivacyComponent,
        PrivacyMockado,
    },
    props: {
        privacy: Object,
    },
    methods: {
        goBack(){
            return window.history.go(-1);
        }
    }
}
</script>
